// extracted by mini-css-extract-plugin
module.exports = {"radio":"styles_radio__2lo65","header":"styles_header__3dVxI","item":"styles_item__IV5Ex","list":"styles_list__3tpQ_"};